/* ============================================================
   Moodi — Gift Cards
   Companion to sections/moodi-gift-cards.liquid

   The carousel is CSS scroll-snap, so touch swipe, momentum and
   keyboard scrolling all work before this file loads. This adds
   two things a native scroll container can't do on its own:
     1. the arrow buttons and their disabled states
     2. click-and-drag with a mouse

   (2) matters because a hidden scrollbar leaves a mouse with no
   way to move the track at all — which is why the carousel looks
   dead in the theme editor's mobile preview even though it swipes
   fine on a real phone.

   Safe to include more than once; instances are flagged rather
   than tracked in a global.
   ============================================================ */
(function () {
  var SELECTOR = '[data-moodi-gift-cards]';
  var SLACK = 2; // scroll-padding means scrollLeft never quite reaches the end

  function step(track) {
    var card = track.querySelector('[data-mgc-card]');
    if (!card) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function syncArrows(el) {
    var track = el.querySelector('[data-mgc-track]');
    var prev = el.querySelector('[data-mgc-prev]');
    var next = el.querySelector('[data-mgc-next]');
    if (!track) return;

    var max = track.scrollWidth - track.clientWidth;
    var scrollable = max > SLACK;

    // No overflow means this breakpoint is in grid mode (or everything fits),
    // so both arrows are dead. The CSS hides them; this also keeps them out of
    // the keyboard order. The same flag drives the grab cursor.
    track.classList.toggle('is-draggable', scrollable);
    if (prev) prev.disabled = !scrollable || track.scrollLeft <= SLACK;
    if (next) next.disabled = !scrollable || track.scrollLeft >= max - SLACK;
  }

  function addDrag(track) {
    var down = false, moved = false, startX = 0, startScroll = 0;

    track.addEventListener('pointerdown', function (e) {
      // Mouse only. Touch and pen already scroll natively, and hijacking them
      // would replace good momentum scrolling with a worse imitation.
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (track.scrollWidth - track.clientWidth <= SLACK) return;
      down = true;
      moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
    });

    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      // A few px of slop so a normal click on a card still registers as a click.
      if (!moved && Math.abs(dx) < 4) return;
      if (!moved) {
        moved = true;
        track.classList.add('is-dragging');
        track.setPointerCapture(e.pointerId);
      }
      track.scrollLeft = startScroll - dx;
      e.preventDefault();
    });

    function end(e) {
      if (!down) return;
      down = false;
      if (!moved) return;
      track.classList.remove('is-dragging');
      try { track.releasePointerCapture(e.pointerId); } catch (err) {}
      // Removing is-dragging restores scroll-snap, which then settles the
      // track onto the nearest card by itself.
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);

    // Swallow the click that follows a drag, so releasing over a linked card
    // doesn't navigate.
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  function init(el) {
    if (el.__mgcInit) return;
    el.__mgcInit = true;

    var track = el.querySelector('[data-mgc-track]');
    var prev = el.querySelector('[data-mgc-prev]');
    var next = el.querySelector('[data-mgc-next]');
    if (!track) return;

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(track), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(track), behavior: 'smooth' });
    });

    addDrag(track);

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        syncArrows(el);
      });
    }, { passive: true });

    // Card widths are a percentage of the track, so a resize — or a breakpoint
    // flip between grid and carousel — changes what "scrollable" means.
    if (window.ResizeObserver) {
      new ResizeObserver(function () { syncArrows(el); }).observe(track);
    } else {
      window.addEventListener('resize', function () { syncArrows(el); });
    }

    syncArrows(el);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  ['shopify:section:load', 'shopify:section:select', 'shopify:block:select'].forEach(function (ev) {
    document.addEventListener(ev, function () { initAll(); });
  });

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();
